import {Component, input, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from "rxjs";
import {DjangoApiService} from "../../../../shared/services/django-api.service";
import {SnackbarService} from "../../../../shared/services/snackbar.service";
import {DatePipe} from "@angular/common";
import {ActivatedRoute} from "@angular/router";
import {LanguageService} from "../../../../shared/services/language.service";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {PdfForPageService} from "../../../../shared/services/pdfMake/pdf-for-page.service";
import {MatAnchor, MatButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatList, MatListItem, MatListItemMeta, MatListItemTitle, MatNavList} from "@angular/material/list";
import {Platform} from "@angular/cdk/platform";
import {TDocumentDefinitions} from "pdfmake/interfaces";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-report-list-public',
  standalone: true,
  imports: [
    MatButton,
  ],
  templateUrl: './report-list-public.component.html',
  styleUrl: './report-list-public.component.css'
})
export class ReportListPublicComponent implements OnInit, OnDestroy {
  reportListData: any[] = [];
  currentLanguage!: string;
  langChangeSubscription: Subscription | null = null;
  productId = input<any>();

  private subscriptions: Subscription = new Subscription();

  constructor(
    private _apiService: DjangoApiService,
    public _route: ActivatedRoute,
    private _languageService: LanguageService,
    private _translate: TranslateService,
    private _platform: Platform) {
  }




  ngOnInit(): void {
    this.setupLanguageSubscription()
    this.loadReportListData();
  }

  private setupLanguageSubscription(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.currentLanguage = event.lang;
      })
    );
  }


  loadReportListData() {
    this.subscriptions.add(
      this._apiService.fetchReportList(this.productId()).subscribe({
        next: (response: any) => {
          this.reportListData = response;
          console.log('reportListData', this.reportListData);
        },
        error: (error) => {
          console.error('There was an error fetching the user information', error);
        }
      })
    );
  }


  // ─── Methode zum Öffnen des PDFs (jeweils in der entsprechenden Sprache) ─────────────
  openPdf(report: any, lang: string, event: MouseEvent): void {
    event.stopPropagation();
    const base64Pdf = report.translations[lang].pdf_file;
    if (base64Pdf) {
      // Base64 in einen Blob umwandeln
      const byteCharacters = atob(base64Pdf);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);

      if (this._platform.ANDROID) {
        // Für Android: PDF herunterladen
        const downloadLink = document.createElement('a');
        downloadLink.href = blobUrl;
        downloadLink.download = 'document.pdf';
        downloadLink.click();
      } else {
        // Für andere Plattformen: PDF in einem neuen Fenster öffnen
        window.open(blobUrl);
      }
    }
  }





  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}
